
import { apiClient } from '@/lib/mockApi';


export const cadastroService = apiClient;

export const fetchCadastros = async () => ({ data: [], error: null });
export const createCadastro = async () => ({ data: [], error: null });
export const updateCadastro = async () => ({ data: [], error: null });
export const deleteCadastro = async () => ({ data: [], error: null });